module.exports = __webpack_public_path__ + "img/midday-background-sm.c7af272c.png";